import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiTrash2, FiCopy } = FiIcons;

const ActionButtons = ({ onEncrypt, onClear, onCopyExisting, isLoadedRedirect }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      className="flex gap-3"
    >
      {/* Show Copy Code button for loaded redirects */}
      {isLoadedRedirect && onCopyExisting ? (
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onCopyExisting}
          className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-medium rounded-xl transition-all duration-200 shadow-lg shadow-green-600/30"
        >
          <SafeIcon icon={FiCopy} className="w-5 h-5" />
          <span>Copy Code</span>
        </motion.button>
      ) : (
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onEncrypt}
          className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-xl transition-all duration-200 shadow-lg shadow-blue-600/30"
        >
          <SafeIcon icon={FiZap} className="w-5 h-5" />
          <span>Encrypt & Copy</span>
        </motion.button>
      )}

      {onClear && (
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onClear}
          className="flex items-center justify-center space-x-2 px-6 py-3 bg-slate-700/50 hover:bg-slate-700/70 text-slate-300 font-medium rounded-xl transition-all duration-200 border border-slate-600/50"
        >
          <SafeIcon icon={FiTrash2} className="w-5 h-5" />
          <span>Clear</span>
        </motion.button>
      )}
    </motion.div>
  );
};

export default ActionButtons;